import { setUploadAvatarModal } from '../../../../../store/workspace/slice';
import { useDispatch, useSelector } from '../../../../../store/store';
import { EditIcon } from '../../../../../assets/icons/common';
import styles from './style.module.scss';
import {
    selectAvatarPhoto,
    selectProfileData,
    selectUserAttributes,
} from '../../../../../store/workspace/selectors';

/** Banner with the applicant's avatar, name and headline expertise. */
function ProfileHeader() {
    const dispatch = useDispatch();
    const avatar = useSelector(selectAvatarPhoto);
    const profile = useSelector(selectProfileData);
    const userAttributes = useSelector(selectUserAttributes);

    return (
        <div className={styles.header}>
            <div className={styles.header_img}>
                {avatar
                    ? <img src={avatar} alt='avatar' />
                    : <span>{userAttributes?.given_name?.slice(0, 1)}</span>}
                <div
                    className={styles.header_img_edit}
                    onClick={() => dispatch(setUploadAvatarModal(true))}
                >
                    <EditIcon width={35} height={35} />
                </div>
            </div>
            <div className={styles.header_text}>
                {userAttributes && <span className={styles.header_text_first_name}>
                    {`${userAttributes['custom:firstName']} ${userAttributes.family_name}`}
                </span>}
                <span className={styles.header_text_expertise}>
                    {profile?.experties?.[0]?.expert.title}
                </span>
            </div>
        </div>
    );
};

export default ProfileHeader;
